import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;


class JournalTypesService {
  create = async (transaction: any) => {
    const res = await axios.post<any>(`${API_URL}journal-type`, transaction)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
    return res.data.entryType;
  };

  get = async (code: any) => {
    const response = await axios.get<any>(`${API_URL}journal-type/${code}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.entryType;
  };

  getAll = async () => {
    const response = await axios.get<any>(`${API_URL}journal-type`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.journalTypes;
  };

  search = async (keyword: any) => {
    const response = await axios.get<any>(`${API_URL}journal-type-search/${keyword}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.journalTypes;
  };
}

export default new JournalTypesService();
